import React, {useState} from 'react';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import {Box, Button, CircularProgress, Divider, Fab, IconButton, Paper, TextField, Typography} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import {CommentWidgetProps} from '../../../../entity/props/comment/comment-widget-props';
import CommentGroup from './CommentGroup';
import {useService} from '../../../../infrastructure/service/service';
import {Form, Formik, FormikHelpers, FormikProps} from 'formik';
import { CommentDto } from '../../../../entity/dto/comment-dto';

import '../../../../assets/css/comment/comment-widget.css';

const CommentWidget = (props: CommentWidgetProps): JSX.Element => {
  const {titleService} = useService();

  const [open, setOpen] = useState<boolean>(false);

  const handleSubmit = async (values: CommentDto, { setSubmitting, resetForm }: FormikHelpers<CommentDto>): Promise<void> => {
    if (!values.comment.trim()) return;

    setSubmitting(true);

    const response = await titleService.addComment(props.title.createdByOrganizationID, props.title.id, values.comment);
    if (response)
      titleService.setTitle(response);

    resetForm();
    setSubmitting(false);
  }

  return (
    <>
      {
        open
          ? <Paper elevation={4} className={'comment-dialog'}>
              <Box className={'comment-dialog-header'}>
                <Typography id={'text-comment-order-number'} variant='subtitle1' fontWeight='bold'>{ props.orderNumber }</Typography>
                <IconButton id={'btn-close-comment'} size='small' className={'comment-dialog-header-icon'} onClick={(): void => setOpen(prevState => !prevState)}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <CommentGroup currentUser={props.currentUser}/>
              <Box sx={{ my: 2, mx: 1 }}>
                <Divider />
                <Formik
                  initialValues={titleService.getCommentDto()}
                  onSubmit={handleSubmit}>
                  {({values, handleChange, handleSubmit, isSubmitting}: FormikProps<CommentDto>): JSX.Element =>
                    <Form onSubmit={handleSubmit}>
                      <Box className={'comment-input-container'}>
                        <TextField
                          id={'input-comment-message'}
                          required
                          label='Type a Message'
                          name='comment'
                          className={'comment-input'}
                          value={values.comment}
                          onChange={handleChange}/>
                        <Button
                          id={'btn-send-comment'}
                          type='submit'
                          disabled={isSubmitting}
                          className='send-button'
                          disableElevation
                          disableRipple
                          disableTouchRipple
                          disableFocusRipple>
                          {
                            isSubmitting
                              ? <CircularProgress size={16} className='comment-icon'/>
                              : <SendIcon className='comment-icon' />
                          }
                        </Button>
                      </Box>
                    </Form>
                  }
                </Formik>
              </Box>
            </Paper>
          : <Fab id={'btn-open-comment'} className={'comment-btn'} onClick={(): void => setOpen(prevState => !prevState)}>
              <QuestionAnswerIcon />
            </Fab>
      }
    </>
  );
}

export default CommentWidget;
